export enum AppRoutes {
  // Test
  TEST = "test",
  // Changelog
  CHANGELOG = "changelog",

  // Section Routes
  DATA_COLLECTION_POL = "data-collection-pol",
  LEADS = "data-collection-leads",
  DATA_COLLECTION = "data-collection",
  REDUCED_DATA_COLLECTION = "data-collection-short",
  OPTIMIZED_DATA_COLLECTION = "optimized-data-collection",
  NEGOTIATION = "negotiation",
  INCOME_DOCUMENATION = "income-documentation",
  KYC = "kyc",
  ADV = "adv",
  QUESTION = "question",
  PERSONAL_AREA = "personal-area",
  OTP = "otp",
  PROGRESS = "progress",
  INSURANCE = "insurance",
  POL = "pol",
  RECOVERY_BLOCK = "recovery-block",
  WELCOME = "welcome",
  SESSION_EXPIRED = "session-expired",

  // Other Routes
  CONTINUE = "continue",
  ASSISTANCE = "assistance",
  SITE_UNDER_MAINTENANCE = "site-under-maintenance",
  OPEN_BANKING_CALLBACK = "ob-callback",

  // Funnel KO
  CANCELLED = "cancelled",
  DECLINED_BY_RULES = "declined-by-rules",
  DECLINED_BY_AML = "declined-by-aml",
  DECLINED_BY_UW = "declined-by-uw",
  OFFER_BUREAU_KO = "offer-bureau-ko",
  // Procedure KO
  OFFERS_EXPIRED = "offers-expired",
  OFFER_SELECTED_EXPIRED = "offer-selected-expired",
  SIGNATURE_REQUIRED_EXPIRED = "signature-required-expired",
  DOCS_REQUIRED_BY_UW_EXPIRED = "docs-required-by-uw-expired",
  DOCS_REQUIRED_BY_AML_EXPIRED = "docs-required-by-aml-expired",
  KYC_EXPIRED = "kyc-expired",
  IDENTIFICATION_IN_PROGRESS = "progress",
  DEADLOCK_FISCAL_CODE = "deadlock-fiscal-code",
}

export enum ProgressRoutes {
  DATA_COLLECTION = "data-collection",
  NEGOTIATION = "negotiation",
  KYC = "kyc",
}

export enum ReducedDataCollectionRoutes {
  PERSONAL_INFO = "personal-info",
  EMPLOYMENT = "employment",
  INCOME_AND_EXPENSES = "income-and-expenses",
  COMPLETE = "complete",
  PRIVACY_CONSENTS = "privacy-consents",
}

export enum DataCollectionRoutes {
  CONTACT_INFO = "contact-info",
  PRIVACY_CONSENTS = "privacy-consents",
  PERSONAL_INFO = "personal-info",
  BIRTH = "birth",
  FISCAL_CODE = "fiscal-code",
  EMPLOYMENT = "employment",
  VAT_NUMBER = "vat-number",
  PENSIONER_INCOME = "pensioner-income",
  HIRING = "hiring",
  JOB = "job",
  COMPANY_SIZE = "company-size",
  COMPANY_INDUSTRY = "company-industry",
  GROSS_INCOME = "gross-income",
  MONTHLY_INCOME = "monthly-income",
  OTHER_INCOME_SOURCES = "other-income-sources",
  PENSIONER_OTHER_INCOME = "pensioner-other-income",
  ADDRESS = "address",
  MARITAL_STATUS = "marital-status",
  FAMILY = "family",
  LIVING_SITUATION = "living-situation",
  COUPON_CODE = "coupon-code",
  LANDING = "landing",
  SELF_OTHER_INCOME = "self-other-income",
}

export enum LeadsRoutes {
  LOAN_INTENT = "loan-intent",
  PRIVACY = "privacy-consents",
}

export enum NegotiationRoutes {
  OFFER = "offer",
  EDIT_OFFER = "offer/edit",
  IBAN = "iban",
  DECLINED_BY_RULES = "declined-by-rules",
  BUREAU_KO = "bureau-ko",
}

export enum KycRoutes {
  COMPLETED = "completed",
}

export enum VideoSelfieRoutes {
  PRIVACY = "privacy",
  DESKTOP = "desktop",
  DOCUMENT_CHOISE = "document-choise",
  FRONT_INSTRUCTION = "front-instruction",
  FRONT_CAPTURE = "front-capture",
  BACK_CAPTURE = "back-capture",
  BACK_INSTRUCTION = "back-instruction",
  SELFIE_INSTRUCTION = "selfie-instruction",
  SELFIE_CAPTURE = "selfie-capture",
  TS_FRONT_INSTRUCTION = "ts-front-instruction",
  TS_FRONT_CAPTURE = "ts-front-capture",
  TS_BACK_INSTRUCTION = "ts-back-instruction",
  TS_BACK_CAPTURE = "ts-back-capture",
  PERMIT_FRONT_INSTRUCTION = "permit-front-instruction",
  PERMIT_FRONT_CAPTURE = "permit-front-capture",
  PERMIT_BACK_INSTRUCTION = "permit-back-instruction",
  PERMIT_BACK_CAPTURE = "permit-back-capture",
  VERIFICATION_ONGOING = "verification-ongoing",
  VERIFICATION_COMPLETE = "verification-complete",
  VERIFICATION_FAILED = "verification-failed",
}

export enum IncomeDocumentationRoutes {
  ACCOUNT_STATEMENT = "account-statement",
  PAYROLL = "payroll",
}

export enum InsuranceRoutes {
  ADVANTAGES = "advantages",
  EXCLUSIONS = "exclusions",
  INFO = "info",
  QUESTIONNAIRE = "questionnaire",
  BENEFICIARY = "beneficiary",
}

export enum BeneficiaryRoutes {
  SELECT = "select",
}

export enum PersonalAreaRoutes {
  LOAN_STATUS = "loan-status",
  LOAN_DETAIL = "loan-detail",

  EMPTY = "no-procedure",
  PROCEDURE_EVALUATION = "procedure-evaluation",
  DOCUMENTATION_REQUIRED = "documentation-required",
  DOCUMENTATION_COMPLETE = "documentation-complete",
  SIGNATURE_REQUIRED = "signature-required",
  LOAN_LIST = "loan-list",
  REPAYMENT_PLAN = "repayment-plan",
  CONTRACT = "contract",
  COMMUNICATION = "communication",
  OTHER_ACTIONS = "other-actions",
  IBAN_CHANGE = "iban-change",
  EARLY_REPAYMENT = "early-repayment",
  NEGATIVE_RESOLUTION = "negative-resolution",
  STARTING_OFFER_DISPLAYED = "starting-offer",
  IBAN_CHANGE_REQUESTED = "iban-change",

  // KO Routes
  // Step checkpoint
  DECLINED_BY_RULES = "declined-by-rules",
  OFFER_BUREAU_KO = "offer-bureau-ko",

  // Procedure status
  CANCELLED = "cancelled",
  OFFERS_EXPIRED = "offers-expired",
  OFFER_SELECTED_EXPIRED = "offer-selected-expired",
  SIGNATURE_REQUIRED_EXPIRED = "signature-required-expired",
  DOCS_REQUIRED_BY_UW_EXPIRED = "uw-required-docs-expired",
  DOCS_REQUIRED_BY_AML_EXPIRED = "aml-required-docs-expired",
  KYC_EXPIRED = "kyc-expired",
  DECLINED_BY_AML = "declined-by-aml",
  DECLINED_BY_UW = "declined-by-uw",
}
